import SolidFoods from '../sections/solidFoods/solidFoods';

export default function SolidFoodsPage() {
  return (
    <div className="section-page">
      <SolidFoods />
    </div>
  );
}
